import React, { FC } from 'react';

import { SportId } from 'app/lib/betting/constants';
import { GridHeader as BettingGridHeader } from 'app/modules/Betting';

type GridHeaderProps = {
  sportId: SportId;
  eventName?: string;
  showColumns?: boolean;
  shouldBeLink?: boolean;
};

const GridHeader: FC<GridHeaderProps> = (props) => (
  <BettingGridHeader {...props} />
);

export default GridHeader;
